import { Component, Output, EventEmitter } from '@angular/core';
import { SitesService } from '@app/services/sites.service';
import { CommonService } from '@app/services/common.service';
import { Helper } from 'src/4services/2helper';
import { BaseComponent } from '@app/directives/base-component';
@Component({
    selector: 'c_side_modal_direction_features_component',
    templateUrl: './c_side_modal_direction_features.component.html',
    styleUrls: ['../../common.scss', '../../c_side_modal.component.scss'],
    standalone: false
})
export class c_side_modal_direction_features_component extends BaseComponent {
  @Output() showPosition = new EventEmitter();
  @Output() hidePosition = new EventEmitter();

  site: any;
  currentRoute = null;
  directionList = [];

  constructor(
    private sitesService: SitesService,
    private helper: Helper,
  ) { super(); }

  async ngOnInit() {
    this.site = this.sitesService.selSite;
    this.directionList = await this.helper.note_directions.get_dealer_monitoring_directions();
  }

  mouseEnterShowPosition(e, type) {
    e?.stopPropagation();
    this.showPosition.emit(type);
  }

  mouseLeaveHidePosition(e) {
    e?.stopPropagation();
    this.hidePosition.emit()
  }
}
